<div>
    <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>

<div *ngIf="isSuccessVisible" class="row alert alert-success alert-dismissible">
    <span class="me-3">
        {{preMessage}}
        <a *ngIf="isSuccessLink" href="javascript:void(0)" (click)="navigateLookup()">{{successSdId}}</a>
        <span *ngIf="!isSuccessLink">{{successSdId}}</span>
        {{postMessage}}
        <button type="button" style='font-size: x-small' class="btn-close" (click)="closeSuccesses()"
            aria-label="Close"></button>
    </span>
</div>

<div *ngIf="isDisplay">

    <div>
        <div>
            <h2> Incoming Transfers</h2>
            <div>
                Below is a list of Short Codes that are pending transfer into your account. If the transfer status is
                pending, click the Accept/Decline button to Accept or Decline the transfer. If the transfer status is
                Accepted, the transfer has been accepted and Customer Support is in the process of completing the
                transfer.  If you have any questions regarding a transfer, contact Customer Support at {{customerSupportPhone}}.
            </div>
            <div>
                <p-table styleClass="p-datatable-striped" id="incomingtable" [value]="incomingTransferList" [sortOrder]="1" [columns]="incomingCols"
                    [scrollable]="true" scrollHeight="50vh"  [paginator]="true" [alwaysShowPaginator]="false" [rows]="30"  currentPageReportTemplate="(Displaying {first} to {last} of {{totalIncomingTransferRecords}})" [showCurrentPageReport]="true"
               (onPage)="loadLazyIncomingTransferList($event)" [totalRecords]='totalIncomingTransferRecords' [lazy]="true" >

                    <ng-template pTemplate="paginatorright" let-state></ng-template>

                    <ng-template pTemplate="header" let-columns>
                        <tr *ngIf="incomingTransferList?.length">
                            <ng-container *ngFor="let col of columns">
                                <th [style.width.%]="col.width">{{col.header}}</th>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field">
                                <div *ngSwitchCase="'scId'">
                                    {{rowData.scId}}
                                </div>
                                <div *ngSwitchCase="'transferStatus'"
                                    [ngStyle]="{'color': rowData.transferStatus === 'Pending' ? '#FF0000' : ''}">
                                    {{rowData.transferStatus }}
                                </div>
                                <div *ngSwitchCase="'fromAccountId'">
                                    {{rowData.fromAccountId }}
                                </div>
                                <div *ngSwitchCase="'fromCompany'">
                                    {{rowData.fromCompany }}
                                </div>
                                <div *ngSwitchCase="'initiatedDate'">
                                    {{rowData.initiatedDate | date:'M/d/yyyy'}}
                                </div>
                                <div *ngSwitchCase="'respondedDate'">
                                    {{rowData.respondedDate | date:'M/d/yyyy'}}
                                </div>
                                <div *ngSwitchCase="'respondedBy'">
                                    {{rowData.respondedBy }}
                                </div>

                                <div *ngSwitchCase="'createTime'">
                                    <button *ngIf="rowData.transferStatus==='Pending'" style="width: 100%;"
                                        type="button"
                                        (click)="acceptDeclineTransfer(rowData.scId,rowData.fromAccountId,rowData.fromCompany,rowData.leaseType,rowData.leaseStatus,rowData.isMonthlyBillingEnabled,rowData.leaseTerm,rowData.leaseExpirationDate,rowData.transferId,rowData.transferStatus, rowData.mbOptOutDate)"
                                        class="btn btn-primary btn-sm">Accept/Decline Transfer</button>
                                    <button *ngIf="rowData.transferStatus==='Accepted'" style="width: 100%;"
                                        type="button"
                                        (click)="directDeclineConfirmation(rowData.scId,rowData.fromAccountId,rowData.transferId)"
                                        class="btn btn-primary btn-sm">Decline Transfer</button>
                                </div>

                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr class="mt-3">
                            <td [attr.colspan]="incomingCols.length" class="noBorder">
                                <b>You currently don't have any incoming transfers.</b>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

        </div>
        <div>
            <h2 class="mt-4 ">Outgoing Transfers</h2>
            <div class="mb-2">Enter a Code to transfer.</div>
            <form #transferForm="ngForm" (ngSubmit)="showShortCodeTransferDialog(transferForm)">
                <div class="row">

                    <div class="col-2">
                        <label for="shortCode" class="required">Short Code</label>
                        <input appAlphaNumOnly appField appScrText required placeholder="Short Code" type="text"
                            id="shortCode" class="form-control form-text" name="shortCode" #shortCode="ngModel"
                            maxlength="6" [(ngModel)]="shortCodeValue" [ngClass]="{'error-input': shortCode.errors }"
                            minlength="5" (keydown.backspace)="shortCodeKeyPress()" />
                    </div>
                    <div class="col-2 d-flex" style="align-self: flex-end;">
                        <button id="transferButton" class="btn btn-primary " submit>Transfer</button>
                    </div>
                </div>
                <div class="row ms-0">
                    <div *ngIf=" transferForm.submitted " class="row ms-0 ">
                        <app-error-msg [field]="shortCode" [fieldLabel]="'Code'"></app-error-msg>
                        <span *ngIf="isSCCustomError" class="inline-error-text">{{isSCCustomErrorMessage}}</span>
                    </div>
                </div>
            </form>
            <div class="mt-3">
                <p-table styleClass="p-datatable-striped" id="outgoingtable" [value]="outgoingTransferList" [sortOrder]="1" [columns]="outgoingCols"
                    [scrollable]="true" scrollHeight="50vh"  [paginator]="true" [alwaysShowPaginator]="false" [rows]="30"  currentPageReportTemplate="(Displaying {first} to {last} of {{totalOutgoingTransferRecords}})" [showCurrentPageReport]="true"
                  (onPage)="loadLazyOutgoingTransferList($event)" [totalRecords]='totalOutgoingTransferRecords' [lazy]="true" >
   
                   
                    <ng-template pTemplate="paginatorright" let-state></ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr *ngIf="outgoingTransferList?.length">
                            <ng-container *ngFor="let col of columns">
                                <th>{{col.header}}</th>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field">
                                <div *ngSwitchCase="'scId'">
                                    {{rowData.scId}}
                                </div>
                                <div *ngSwitchCase="'transferStatus'"
                                    [ngStyle]="{'color': rowData.transferStatus === 'Pending' ? '#FF0000' : ''}">
                                    {{rowData.transferStatus }}
                                </div>
                                <div *ngSwitchCase="'toAccountId'">
                                    {{rowData.toAccountId }}
                                </div>
                                <div *ngSwitchCase="'toCompany'">
                                    {{rowData.toCompany }}
                                </div>
                                <div *ngSwitchCase="'initiatedDate'">
                                    {{rowData.initiatedDate | date:'M/d/yyyy'}}
                                </div>
                                <div *ngSwitchCase="'initiatedBy'">
                                    {{rowData.initiatedBy }}
                                </div>
                                <div *ngSwitchCase="'respondedDate'">
                                    {{rowData.respondedDate| date:'M/d/yyyy' }}
                                </div>
                                <div *ngSwitchCase="'createTime'">
                                    <button
                                        (click)="cancelTransfer(rowData.scId,rowData.toAccountId, rowData.transferId)"
                                        class="btn btn-primary btn-sm">Cancel Transfer</button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr class="mt-3">
                            <td [attr.colspan]="outgoingCols.length" class="noBorder">
                                <b>You currently don't have any outgoing transfers.</b>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

        </div>
        <div>
            <h2 class="mt-4 ">Transfer History</h2>
            <div>You can download a report of your Transfer History in <a class="link" href="javascript:void(0)"
                    (click)="navigateReports()">Reports.</a></div>
        </div>
    </div>
</div>
<p-confirmDialog key='cancelTransfer' #cancelTransferDialog width="425" [closable]="false">
    <p-footer>
        <button i18n id="scaccept" class="btn btn-primary me-2" (click)="cancelTransferDialog.accept()">Yes</button>
        <button i18n id="screject" class="btn btn-secondary" (click)="cancelTransferDialog.reject()">No</button>
    </p-footer>
</p-confirmDialog>

<p-confirmDialog key='declineTransferConfirmation' #declineTransferConfirmationDialog width="425" [closable]="false">
    <p-footer>
        <button i18n id="scaccept" class="btn btn-primary me-2"
            (click)="declineTransferConfirmationDialog.accept()">OK</button>
        <button i18n id="screject" class="btn btn-secondary"
            (click)="declineTransferConfirmationDialog.reject()">Cancel</button>
    </p-footer>
</p-confirmDialog>

<app-short-code-transfers-dialog [style]="{width: '40vw'}" [scId]="searchShortCodeValue"
    (transferCodeClick)="transferEventHandler($event)">
</app-short-code-transfers-dialog>

<app-accept-decline-transfers-dialog [style]="{width: '40vw'}" [scId]="searchShortCodeValue"
    [fromAccountID]="fromAccountID" [fromCompany]="companyName" [leaseType]="leaseType" [term]="leaseTerm"
    [leaseStatus]="leaseStatus" [MonthlyBilling]="MonthlyBillingEnabled" [expirationDate]="expirationDate"
    [transferId]="transferId" [transferStatus]="transferStatus" [mbOptOutDate]="mbOptOutDate" (transferCodeClick)="transferEventHandler($event)">
</app-accept-decline-transfers-dialog>